import { Component, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedDataService } from '../../../services/shared-data.service';
import { Dashboard, LabelTypes } from '../../../shared/label.types';
import { LabelService } from '../../../services/label.service';
import { OutsideClickDirective } from '../../../directives/outside-click.directive';
import { DashboardOptions } from '../../../shared/models/dashboard.types';

@Component({
  selector: 'more-drop-down',
  standalone: true,
  imports: [OutsideClickDirective, CommonModule],
  templateUrl: './more-drop-down.component.html',
  styleUrl: './more-drop-down.component.scss',
})
export class MoreDropDownComponent {
  protected _dropdownOpened = signal<boolean>(false);

  protected dashboardOptionClicked = output<DashboardOptions>()

  dashboard: Dashboard = {} as Dashboard;

  constructor(
    private sharedDataService: SharedDataService,
    public labelService: LabelService,
  ) {}

  ngOnInit() {
    this.sharedDataService.getToggleValues().subscribe((values) => {
      this._dropdownOpened.set(values.moreOptions);
    });
    this.labelService.getLabelData().subscribe((data: LabelTypes) => {
      this.dashboard = data?.dashboard ?? {};
    });
  }

  toggleMoreDropdown(event: MouseEvent) {
    this.sharedDataService.toggleMore(!this._dropdownOpened());
    event?.stopPropagation();
  }

  onOutsideClick = () => {
    this.sharedDataService.toggleMore(false);
  };

  handleReportClick() {
    this.sharedDataService.toggleMore(false);
    this.dashboardOptionClicked.emit('customer_report');
  }

  //download table data csv file
  onDownload() {
    this.sharedDataService.toggleMore(false);
    this.dashboardOptionClicked.emit('download_csv');
  }
}
